import Oncologia from "_+_Portal/pages/Oncología/Oncología";
import OrdenesDigitales from "_+_Portal/pages/OrdenesDigitales/OrdenesDigitales";
import AtencionSinTurno from "../pages/AtencionSinTurno/AtencionSinTurno";
import ConsultaMedica from "../pages/ConsultaMedica/ConsultaMedica";
import Estudios from "../pages/Estudios/Estudios";
import GrupoFamiliar from "../pages/GrupoFamiliar/GrupoFamiliar";
import Home from "../pages/Home/Home";
import Laboratorio from "../pages/Laboratorio/Laboratorio";
import Login from "../pages/Login/Login";
import LoginToken from "../pages/Login/LoginToken";
import MisInformes from "../pages/MisInformes/MisInformes";
import MisLaboratorios from "../pages/MisLaboratorios/MisLaboratorios";
import MisMedicos from "../pages/MisMedicos/MisMedicos";
import Notificaciones from "../pages/Notificaciones/Notificaciones";
import PaginaNoEncontrada from "../pages/PaginaNoEncontrada/PaginaNoEncontrada";
import Perfil from "../pages/Perfil/Perfil";
import PortalPCR from "../pages/PortalPCR/PortalPCR";
import ProximosTurnos from "../pages/ProximosTurnos/ProximosTurnos";
import RecetasDigitales from "../pages/RecetasDigitales/RecetasDigitales";
import Sugerencias from "../pages/Sugerencias/Sugerencias";
import TurnosDisponibles from "../pages/TurnosDisponibles/TurnosDisponibles";
import TurnosDisponiblesKin from "../pages/TurnosDisponibles/TurnosDisponiblesKin";
import TurnosDisponiblesPcr from "../pages/TurnosDisponibles/TurnosDisponiblesPcr";
import VideoTutoriales from "../pages/VideoTutoriales/VideoTutoriales";
import Beneficios from "_+_Portal/pages/Beneficios/Beneficios";
import BuscadorTurnos from "_+_Portal/pages/BuscadorTurnos/BuscadorTurnos";
import MisRecetas from "_+_Portal/pages/MisRecetas/MisRecetas";
import MisCertificados from "_+_Portal/pages/MisCertificados/MisCertificados";
import TurnosDisponibles2 from "_+_Portal/pages/TurnosDisponibles/TurnosDisponibles2";
import PreguntasFrecuentes from "_+_Portal/pages/PreguntasFrecuentes/PreguntasFrecuentes";

const routes = [
  {
    id: 1,
    path: "/login",
    component: Login,
    title: "Login",
    needsAuth: false,
  },
  {
    id: 2,
    path: "/auth/login",
    component: Login,
    title: "Login",
    needsAuth: false,
  },
  {
    id: 3,
    path: "/loginpcr",
    component: PortalPCR,
    title: "Portal Exterior PCR",
    needsAuth: false,
  },
  {
    id: 4,
    path: "/notfound",
    component: PaginaNoEncontrada,
    title: "Página no encontrada",
    needsAuth: false,
  },
  {
    id: 5,
    path: "/turnosdisponiblespcr",
    component: TurnosDisponiblesPcr,
    title: "Turnos Disponibles PCR",
    needsAuth: true,
  },
  {
    id: 6,
    path: "/home",
    component: Home,
    title: "Home",
    needsAuth: true,
  },
  {
    id: 7,
    path: "/auth/activacion",
    component: LoginToken,
    title: "Activación",
    needsAuth: false,
  },
  {
    id: 8,
    path: "/perfil",
    component: Perfil,
    title: "Perfil",
    needsAuth: true,
  },
  {
    id: 9,
    path: "/consultamedica",
    component: ConsultaMedica,
    title: "Buscador Consulta Médica",
    needsAuth: true,
  },
  {
    id: 10,
    path: "/estudios",
    component: Estudios,
    title: "Buscador Estudio",
    needsAuth: true,
  },
  {
    id: 11,
    path: "/laboratorio",
    component: Laboratorio,
    title: "Buscador Laboratorio",
    needsAuth: true,
  },
  {
    id: 12,
    path: "/recetasDigitales",
    component: RecetasDigitales,
    title: "Buscador Recetas Digitales",
    needsAuth: true,
  },
  {
    id: 13,
    path: "/proximosTurnos",
    component: ProximosTurnos,
    title: "Próximos Turnos",
    needsAuth: true,
  },
  {
    id: 13.1,
    path: "/turnoReservado",
    component: ProximosTurnos,
    title: "Próximos Turnos",
    needsAuth: true,
  },
  {
    id: 14,
    path: "/turnosDisponibles",
    component: TurnosDisponibles2,
    title: "Turnos Disponibles",
    needsAuth: true,
  },
  {
    id: 15,
    path: "/turnosDisponiblesKinesiologia",
    component: TurnosDisponiblesKin,
    title: "Turnos Disponibles Kinesiología",
    needsAuth: true,
  },
  {
    id: 16,
    path: "/videoConsulta",
    component: ProximosTurnos, //proximosTurnos (filtrado)
    title: "Video Consulta",
    needsAuth: true,
  },
  {
    id: 17,
    path: "/atencionSinTurno",
    component: AtencionSinTurno,
    title: "Atención sin turno previo",
    needsAuth: true,
  },
  {
    id: 18,
    path: "/testpcr",
    component: Laboratorio,
    title: "Test PCR",
    needsAuth: true,
  },
  {
    id: 19,
    path: "/misLaboratorios",
    component: MisLaboratorios,
    title: "Mis Laboratorios",
    needsAuth: true,
  },
  {
    id: 20,
    path: "/misInformes",
    component: MisInformes,
    title: "Mis Informes",
    needsAuth: true,
  },
  {
    id: 21,
    path: "/GrupoFamiliar",
    component: GrupoFamiliar,
    title: "Mi Grupo Familiar",
    needsAuth: true,
  },
  {
    id: 22,
    path: "/mismedicos",
    component: MisMedicos,
    title: "Mis Médicos",
    needsAuth: true,
  },
  {
    id: 23,
    path: "/sugerencia",
    component: Sugerencias,
    title: "Sugerencia",
    needsAuth: true,
  },
  {
    id: 24,
    path: "/videoTutoriales",
    component: VideoTutoriales,
    title: "Video Tutorial",
    needsAuth: true,
  },
  {
    id: 25,
    path: "/",
    component: Login,
    title: "Login",
    needsAuth: false,
  },
  {
    id: 26,
    path: "/notificaciones",
    component: Notificaciones,
    title: "Notificaciones",
    needsAuth: true,
  },
  {
    id: 27,
    path: "/oncologia",
    component: Oncologia,
    title: "Oncología",
    needsAuth: true,
  },
  {
    id: 28,
    path: "/ordenesDigitales",
    component: OrdenesDigitales,
    title: "Ordenes Digitales",
    needsAuth: true,
  },
  {
    id: 29,
    path: "/beneficiosDim",
    component: Beneficios,
    title: "Beneficios DIM",
    needsAuth: false,
  },
  {
    id: 30,
    path: "/buscadorTurnos",
    component: BuscadorTurnos,
    title: "Buscador Turnos",
    needsAuth: true,
  },
  {
    id: 31,
    path: "/misRecetas",
    component: MisRecetas,
    title: "Mis Recetas",
    needsAuth: true,
  },
  {
    id: 32,
    path: "/certificados",
    component: MisCertificados,
    title: "Ver Certificados",
    needsAuth: true,
  },
  {
    id: 33,
    path: "/preguntasFrecuentes",
    component: PreguntasFrecuentes,
    title: "Preguntas Frecuentes",
    needsAuth: true,
  },
];

export default routes;
